import script from "./CalendarInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarInput.vue?vue&type=script&setup=true&lang=js"

import "./CalendarInput.vue?vue&type=style&index=0&id=afd62b6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afd62b6c"]])

export default __exports__